export class InstoreLists {
    state: string;
    message: string;
    result: InstoreInformation[];
}

export class MailRequest {
    state: string;
    message: string;
}
export class InstoreInformation {
    id:              number;
    name:            string;
    region_id:       number;
    showroom_id:     number;
    floor_id:        number;
    location_id:     number;
    asset_type_id:   number;
    creative_id:     number;
    size_w:          number;
    size_h:          number;
    asset_count:     number;
    install_date:    Date;
    expiry_date:     Date;
    particulars:     string;
    image:           string;
    vendor_id:       number;
    is_installed:    number;
    is_suspended:    number;
    is_deleted:      number;
    is_discontinued: number;
    created_by:      number;
    created_time:    number;
    modified_by:     number;
    modified_time:   number;
    lastChanged:     Date;
    expiryDays:      number;
    assetTypeName:   string;
    creativeName:    string;
    floorName:       string;
    locationName:    string;
    regionName:      string;
    showroomName:    string;
    vendorName:      string;
    firstChanged: string;
}
export class CampaignLists {
    state: string;
    message: string;
    result: CampaignInformation[];
}
export class CampaignInformation {
    id:              number;
    festival_id:     number;
    festival_name:   string;
    region_id:       number;
    showroom_id:     number;
    start_date:      Date;
    end_date:        Date;
    asset_type_id:   number;
    creative_id:     number;
    size_w:          number;
    size_h:          number;
    particulars:     string;
    image:           string;
    cost:            number;   
    vendor_id:       number;
    is_suspended:    number;
    is_deleted:      number;
    created_by:      number;
    created_time:    number;
    modified_by:     number;
    modified_time:   number;
    lastChanged:     Date;
    assetTypeName:   string;
    creativeName:    string;
    regionName:      string;
    showroomName:    string;
    vendorName:      string;
    firstChanged: string;
}
/* - - - - - - - Vinay - - - - - - - - */
export class ExcelHoarding {
    region: string = "";
    showroom: string = "";
    area: string = "";
    assets: string = "";
    creative: string = "";
    particulars: string = "";
    width: string= "";
    height: string = "";
    cost: string = "";
    name:string = "";
    vendor: string = "";
    // lat: string = "";
    // long: string = "";
    installation_date: string = "";
    expiry_date:string = "";
    address:string="";
    image:string="";
    region_id: string = "";
    showroom_id: string = "";
    location_id: string= "";
    floor_id: string= "";
    asset_type_id: string= "";
    creative_id: string= "";
    vendor_id: string= "";

    
}
export class ExcelInstore {
    region: string = "";
    showroom: string = "";
    floor: string = "";
    location: string = "";
    assets: string = "";
    creative: string = "";
    particulars: string = "";
    size_w: string= "";
    size_h: string = "";
    name:string = "";
    vendor: string = "";
    installation_date: string="";
    expiry_date:string= "";
    image:string="";
    // region_id: string = "";
    // showroom_id: string = "";
    // location_id: string= "";
    // floor_id: string= "";
    // asset_type_id: string= "";
    // creative_id: string= "";
    // vendor_id: string= "";
    
}
// Mostly Used BulkUpload
export class Instore { 
    region: string = "";
    showroom: string = "";
    floor: string = "";
    location: string = "";
    asset_type: string = "";
    creative: string = "";
    particulars: string = "";
    vendor: string = "";
    name:string = "";
    size_w: string= "";
    size_h: string = "";
    install_date: string="";
    uploaded_date?: string="";
    expiry_date:string= "";
    region_id?: string = "";
    showroom_id?: string = "";
    location_id?: string= "";
    floor_id?: string= "";
    asset_type_id?: string= "";
    creative_id?: string= "";
    vendor_id?: string= "";
    image?:string="";
    id?: string= "";
}
export class Campaign {
    region: string = "";
    showroom: string = "";
    floor: string = "";
    location: string = "";
    assets_type: string = "";
    creative: string = "";
    vendor: string = "";
    particulars: string = "";
    cost: string="";
    name:string = "";
    width: string= "";
    height: string = "";
    installation_date:string="";
    uploaded_date:string="";
    expiry_date:string= "";
    region_id: string = "";
    showroom_id: string = "";
    location_id: string= "";
    floor_id: string= "";
    assets_id: string= "";
    creative_id: string= "";
    vendor_id: string= "";
}
export class Hoarding {
    area: string = "";
    region: string = "";
    showroom: string = "";
    asset_type?: string = "";
    creative: string = "";
    vendor: string = "";
    particulars: string = "";
    cost: number = 0;
    name: string = "";
    size_w: string= "";
    size_h: string = "";
    install_date:string="";
    uploaded_date?:string="";
    expiry_date:string= "";
    region_id?: string = "";
    showroom_id?: string = "";
    assets_id?: string= "";
    creative_id?: string= "";
    vendor_id?: string= "";
    // lang: string = "";
    // lat: string = "";
    image?:string="";
    address?:string="";
    asset_type_id?: string= "";
    squarefeet?: string = "";
    id?: string = "";
}
export class BulkInstoreValResponse {
    state: string;
    results: Instore[];
}
export class BulkInstoreUploadResponse {
    state: string;
    message: string;
}
export class BulkHoardingValResponse {
    state: string;
    results: Hoarding[];
}

export class Excel_InstoreExport
{
  REGION: string="";
  SHOWROOM:string="";
  FLOOR:string="";
  LOCATION:string="";
  TYPE:string="";
  CREATIVE:string="";
  PARTICULARS:string="";
  WIDTH:Number;
  HEIGHT:Number;
  NAME:string="";
  VENDOR:string="";
  INSTALLATION_DATE:Date;
  EXPIRY_DATE:Date;
  IMAGE:string="";
  EXPIRY_DAYS:number;
}

export class Excel_HoardingExport
{
  REGION: string="";
  SHOWROOM:string="";
  AREA:string="";
  TYPE:string="";
  CREATIVE:string="";
  PARTICULARS:string="";
  WIDTH:Number;
  HEIGHT:Number;
  COST:Number;
  NAME:string="";
  VENDOR:string="";
  INSTALLATION_DATE:Date;
  EXPIRY_DATE:Date;
  ADDRESS:string="";
  IMAGE:string="";
  EXPIRY_DAYS:number;
  
}
/* - - - - - - - Vinay - - - - - - - - */